import ResizeObserver from 'resize-observer-polyfill';
import accordion from '../../styles/variables/accordion.module.scss';
import debounce from './debounce';

// Accesibility reference: https://www.w3.org/TR/wai-aria-practices-1.1/#accordion
const initAccordion = ({ button }) => {
  let closingTransitionID = null;

  const content = document.querySelector(button.dataset.target);
  if (!content) {
    return;
  }

  const resizeObserver = new ResizeObserver(debounce(() => {
    // When content resizes, set a new max height based on scrollHeight.
    const height = content.scrollHeight;
    const prevMaxHeight = parseInt(content.style.maxHeight);
    if (!prevMaxHeight || Math.abs(height - prevMaxHeight) > 1) {
      // Only change height if there is an actual change.
      // Fixes bug in Firefox.
      content.style.maxHeight = `${height}px`;
    }
  }, 50));

  const clearTransition = () => {
    // Prevents non-responsivity during transition or fast clicks.
    if (closingTransitionID) {
      clearTimeout(closingTransitionID);
    }
  };

  const openAccordion = () => {
    // Maintain open accordion height.
    resizeObserver.observe(content, { box: 'border-box' });
    // Set accordion to open.
    button.classList.add('open');
    button.setAttribute('aria-expanded', 'true');
    content.removeAttribute('hidden');

    // Needed for IE11 - won't initially respond to resize observer without forcing height change
    content.style.maxHeight = `${content.scrollHeight}px`;
  };

  const closeAccordion = () => {
    // Stop observing resizes for height changes.
    resizeObserver.unobserve(content);
    // Collapse accordion.
    content.style.removeProperty('max-height');
    // Set accordion to closed.
    button.classList.remove('open');
    button.setAttribute('aria-expanded', 'false');
    // Hide after transition.
    closingTransitionID = setTimeout(() => {
      content.setAttribute('hidden', '');
    }, accordion.transitionSpeed);
  };

  const toggleAccordion = () => {
    // Dispose of the old transition so that a new one may immediately begin.
    clearTransition();
    // Toggle open.
    if (button.classList.contains('open')) {
      closeAccordion();
    } else {
      openAccordion();
    }
  };

  button.addEventListener('click', (e) => {
    e.preventDefault();
    toggleAccordion();
  });
};

export default () => {
  const accordionButtons = Array.from(document.querySelectorAll("[data-accordion-button]"));
  if (!accordionButtons.length) {
    return;
  }

  accordionButtons.forEach((button) => initAccordion({ button }));
};
